module.exports = __webpack_public_path__ + "img/pic.e01896e0.jpg";